<template>
  <v-layout
    v-if="!items.length"
    justify-center
    align-center
  >
    No added {{ itemsName }}
  </v-layout>

  <v-layout
    v-else
    column
  >
    <v-layout
      v-for="(item, i) in items"
      :key="i"
      :class="{ 'mt-2': i > 0 }"
      align-center
      justify-space-between
    >
      <strong :class="{ 'white--text': $vuetify.theme.dark }">
        {{ getItemLabel(item) }}
      </strong>

      <v-btn
        :loading="loading"
        icon
        small
        color="error"
        @click="$emit('remove', item)"
      >
        <v-icon>
          delete
        </v-icon>
      </v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: 'AddedDependenciesList',

  props: {
    items: {
      type: Array,
      required: true,
    },

    itemsName: {
      type: String,
      required: true,
    },

    loading: {
      type: Boolean,
      required: true,
    },

    getItemLabel: {
      type: Function,
      default: item => item,
    },
  },
};
</script>
